import React from "react";

import "../../Common.scss";
import "./Footer.scss";
import SkeletonProduct  from "../../Pages/Skeleton/index.jsx";

export default class Footer extends React.Component{
//function Footer(props) {
  constructor(props) {
    super(props);
    this.state = {
      loader : false,
      loader1 : false,
      loader2 : false,
      loader3 : false,
    }
  }
  render = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="info">
          <div className="img-box">
            <img src="../images/logo.png" alt="Logo" />
          </div>
          {!this.state.loader ? (
          <p>
            The world’s first and largest digital marketplace for crypto
            collectibles and non-fungible tokens (NFTs). Buy, sell, and discover
            exclusive digital items.
          </p>
           ) :  [1].map(loading =>(
                  <>
                    <div className="skeleton-items" key={loading}>
                    <SkeletonProduct />
                    </div>
                  </>
            ))}
          <ul className="social">
            <li key="0">
              <a href="/" className="fb">
                <img src="../images/fb.png" alt="fb" />
              </a>
            </li>
            <li key="1">
              <a href="/" className="tw">
                <img src="../images/tw.png" alt="fb" />
              </a>
            </li>
            <li key="2">
              <a href="/" className="in">
                <img src="../images/in.png" alt="fb" />
              </a>
            </li>
          </ul>
        </div>
        <div className="market-place">
          <h4>Market Place</h4>
          {!this.state.loader1 ? (
          <ul className="footer-links">
            <li key="0">
              <a href="/ExploreNfts">All NFTs</a>
            </li>
            <li key="1">
              <a href="/category/?name=art">Art</a>
            </li>
            <li key="2">
              <a href="/category/?name=Photography">Photography</a>
            </li>
            <li key="3">
              <a href="/category/?name=sports">Sports</a>
            </li>
            <li key="4">
              <a href="/category/?name=Collectibles">Collectibles</a>
            </li>
            <li key="5">
              <a href="/category/?name=music">Music</a>
            </li>
            <li key="6">
              <a href="/category/?name=Domain Names">Domain Name</a>
            </li>
            <li key="7">
              <a href="/category/?name=Metaverse">Metaverse</a>
            </li>
          </ul>
           ) :  [1].map(loading =>(
             <>
              <div className="skeleton-items"  key={loading}>
              <SkeletonProduct />
              </div>
            </>
          ))}
        </div>
        <div className="market-place">
          <h4>My Account</h4>
          {!this.state.loader2 ? (
          <ul className="footer-links">
            <li key="0">
              <a href="/UserProfile">Profile</a>
            </li>
            {/* <li>
              <a href="/">Favorite</a>
            </li> */}
            <li key="1">
              <a href="/MyCollections">My Collections</a>
            </li>
            {/* <li key="2">
              <a href="/">Settings</a>
            </li> */}
          </ul>
          ) :  [1].map(loading =>(
                  <>
                    <div className="skeleton-items" key={loading}>
                    <SkeletonProduct />
                    </div>
                  </>
            ))}
        </div>
        <div className="stay-loop">
          <h4>Stay in the loop</h4>
          {!this.state.loader3 ? (
          <p>
            Join our mailing list to stay in the loop with our newest feature
            releases, NFT drops, and tips and tricks for navigating NFTs.
          </p>
          ) :  [1].map(loading =>(
            <>
              <div className="skeleton-items" key={loading}>
              <SkeletonProduct />
              </div>
            </>
        ))}
          <div className="subscribe">
            <input type="email" placeholder="Enter your email address.." />
            <button className="button">Subscribe Now</button>
          </div>
        </div>
      </div>
    </footer>
  );
  }
}

//export default Footer;
